module.exports = __webpack_public_path__ + "img/cloud-background-top.954f676a.png";